import * as React from 'react';
import * as _ from 'underscore';

import { CollectionSpaceHeaderProps } from './CollectionSpaceHeader';
import { CollectionsResourceQuery } from './Collections';
import { InlineEditableDescriptionProps, InlineEditableDescription } from '../Header/InlineEditableDescription';
import { DESCRIPTION_MAX_LENGTH } from '../../content/contentDetailDialog/DescriptionDetailSection';

export function EditableCollectionDescriptionInline(props: CollectionSpaceHeaderProps): JSX.Element {
  const updateDescription = React.useCallback(
    async (description: string): Promise<void> => {
      const updatedCollectionData = {
        description: description
      };
      await (new CollectionsResourceQuery()).update(props.item.luid, updatedCollectionData);
    },[props.item.luid]
  );


  const descriptionProps: InlineEditableDescriptionProps = {
    ...props,
    maxCharacterCount: DESCRIPTION_MAX_LENGTH,
    updateDescription: updateDescription,
    sanitizer: props.sanitizer,
  };

  return <InlineEditableDescription {...descriptionProps} />;
}